export default "__VITE_ASSET__Db0mkPiZ__"